import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Button from 'components/ui/Button';
import { Column } from 'components/shared/Layout';

import { StyledInputContainer, StyledForm, StyledText } from './SplitPayment.styles';
import CurrencySymbol from 'components/ui/CurrencySymbol';

const SplitPayment = ({
  hideSubmit,
  disabled,
  children,
  title,
  subTitle,
  label,
  onSubmit,
  loading,
  isCashPayment = false,
  totalPriceToBePaid,
  changeDue,
  currency,
  addBreak
}) => (
  <StyledForm onSubmit={onSubmit} addBreak={addBreak}>
    <div>
      <p>{title}</p>
      <small>{subTitle}</small>
    </div>
    {isCashPayment ? (
      <>
        <StyledInputContainer data-cy="split-balance-due">
          <StyledText>
            <FormattedMessage id="payments.balanceDue" />
          </StyledText>
          <CurrencySymbol currencyCode={currency} />
          {totalPriceToBePaid.toFixed(2)}
        </StyledInputContainer>
        <StyledInputContainer data-cy="split-payments">
          <StyledText>
            <FormattedMessage id="payments.cashReceived" />
          </StyledText>
          {children}
        </StyledInputContainer>
        <StyledInputContainer data-cy="split-change-due">
          <StyledText>
            <FormattedMessage id="payments.change" />
          </StyledText>
          <CurrencySymbol currencyCode={currency} />
          {changeDue >= 0 ? changeDue.toFixed(2) : 0}
        </StyledInputContainer>
      </>
    ) : (
      <StyledInputContainer data-cy="split-payments">{children}</StyledInputContainer>
    )}

    {!hideSubmit && (
      <Column>
        <Button data-cy="submit-payment" type="submit" loading={loading} disabled={!!(loading || disabled)} variant="primary">
          {label}
        </Button>
      </Column>
    )}
  </StyledForm>
);

SplitPayment.propTypes = {
  isCashPayment: PropTypes.bool,
  totalPriceToBePaid: PropTypes.number,
  changeDue: PropTypes.number,
  currency: PropTypes.string,
  'totalPriceToBePaid.toFixed': PropTypes.number,
  'changeDue.toFixed': PropTypes.number,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  title: PropTypes.node,
  subTitle: PropTypes.node,
  label: PropTypes.node,
  onSubmit: PropTypes.func,
  hideSubmit: PropTypes.bool,
  addBreak: PropTypes.bool
};

SplitPayment.defaultProps = {
  hideSubmit: false
};

export default SplitPayment;
